/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

const icons: Record<string, (props: React.SVGProps<SVGSVGElement>) => JSX.Element> = {
  roundedCheckmark: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="30" cy="30" r="30" fill="#2FAEF3" />
      <path
        d="M15.7634 31.7518C13.5285 29.5168 16.6946 26.1645 18.9295 28.2131L25.2618 34.1729L37.9264 20.7634C40.1613 18.5285 43.5137 21.6946 41.465 23.9295L26.938 39.2015C26.0068 40.1327 24.7031 40.319 23.5856 39.3878L15.7634 31.7518Z"
        fill="white"
      />
    </svg>
  ),
  checkmark: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21" {...props}>
      <path
        d="M23.034 1.974 10.328 14.658 4.39 8.496a2.003 2.003 0 0 0-2.903-.01 2.179 2.179 0 0 0-.003 3.002l7.387 7.632c.366.42.894.649 1.44.623a2.26 2.26 0 0 0 1.429-.578L25.866 5.056a2.17 2.17 0 0 0 .106-2.967 2.07 2.07 0 0 0-2.938-.115Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  ),
  loader: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40"
      height="40"
      viewBox="0 0 50 50"
      {...props}
    >
      <path
        fill="currentColor"
        d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  ),
  close: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7327 24.5C22.2602 24.4968 21.8076 24.3096 21.471 23.9781L1.04789 3.55501C0.722644 3.22316 0.539737 2.77749 0.538097 2.31283C0.536457 1.84817 0.716214 1.40121 1.03911 1.06708C1.36201 0.732942 1.80256 0.538008 2.267 0.523758C2.73145 0.509509 3.18312 0.67707 3.52589 0.990783L3.57128 1.03163L23.9943 21.4547C24.2418 21.705 24.4099 22.0227 24.4775 22.3681C24.5452 22.7135 24.5094 23.0712 24.3747 23.3963C24.24 23.7215 24.0123 23.9996 23.7202 24.196C23.4281 24.3923 23.0846 24.4981 22.7327 24.5Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M2.28194 24.4864C1.92938 24.487 1.58461 24.3828 1.29137 24.1871C0.99814 23.9914 0.769673 23.7129 0.634972 23.3871C0.500271 23.0613 0.46541 22.7028 0.534815 22.3571C0.604219 22.0115 0.774759 21.6942 1.02479 21.4457L21.4479 1.02261C21.7825 0.687988 22.2363 0.5 22.7096 0.5C23.1828 0.5 23.6366 0.687988 23.9712 1.02261C24.3059 1.35723 24.4939 1.81108 24.4939 2.2843C24.4939 2.75753 24.3059 3.21137 23.9712 3.54599L3.54817 23.9691C3.38214 24.1352 3.18463 24.2665 2.9672 24.3554C2.74977 24.4442 2.51681 24.4888 2.28194 24.4864Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  ),
  arrowDown: (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowNext: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.712 9.73599L2.70401 16.744C2.29601 17.128 1.67201 17.128 1.28801 16.744C0.904009 16.36 0.904009 15.736 1.28801 15.328L7.6 9.01599L1.28801 2.70399C0.90401 2.31999 0.90401 1.67199 1.28801 1.28799C1.67201 0.903995 2.29601 0.903995 2.70401 1.28799L9.712 8.31999C10.096 8.70399 10.096 9.32799 9.712 9.73599Z"
        strokeWidth="1.5"
      />
    </svg>
  ),
  goBack: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <circle cx="25" cy="25" r="24" fill="#EEFBFF" stroke="#2FAEF3" strokeWidth="2" />
      <path
        d="M33.55 23.589a1.44 1.44 0 0 0-.248-.019H19.12l.31-.143c.302-.143.577-.338.812-.576l3.977-3.977c.524-.5.612-1.304.209-1.906a1.439 1.439 0 0 0-2.158-.187l-7.192 7.192a1.439 1.439 0 0 0 0 2.036l7.192 7.192a1.438 1.438 0 0 0 2.158-.144 1.489 1.489 0 0 0-.209-1.906l-3.97-3.985a2.878 2.878 0 0 0-.719-.524l-.431-.195h14.125a1.489 1.489 0 0 0 1.517-1.208 1.439 1.439 0 0 0-1.19-1.65Z"
        fill="#2FAEF3"
      />
    </svg>
  ),
  creditCard: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 16" {...props}>
      <path
        d="M.998 0A.986.986 0 0 0 0 1.001V4h24.993V1.001A.988.988 0 0 0 23.995 0H.998ZM0 6.498v8.5A.988.988 0 0 0 .998 16h22.997a.986.986 0 0 0 .998-1.001V6.498H0Zm19.497 3.75h3v3h-3v-3Zm-16.518 2h4.997v1H2.979v-1Z"
        fill="#6D6D6D"
      />
    </svg>
  ),
  tabDropdown: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5 8L0.669872 0.499999L9.33013 0.5L5 8Z" fill="#303030" />
    </svg>
  ),
  sendMsg: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width="14"
      height="14"
      {...props}
    >
      <path d="M13.066 6.997a.883.883 0 0 0-.132-.464.856.856 0 0 0-.353-.321L1.22.682a.832.832 0 0 0-.958.164.886.886 0 0 0-.183.975l1.973 4.541a1.6 1.6 0 0 1 0 1.27L.083 12.17a.875.875 0 0 0 .162.977.825.825 0 0 0 .958.164L12.56 7.79a.854.854 0 0 0 .368-.32.883.883 0 0 0 .139-.472ZM2.986 5.94l-1.792-4.1 9.557 4.638h-7.6a2.91 2.91 0 0 0-.166-.538Zm-1.792 6.21 1.791-4.09c.076-.171.132-.351.168-.535h7.6L1.195 12.15Z" />
    </svg>
  ),
  thickDropdown: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      fill="none"
      width="8"
      height="9"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 8"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.486 7.447.15 1.667A1.114 1.114 0 0 1 1.111 0h6.675c.85 0 1.388.93.962 1.667l-3.337 5.78c-.425.737-1.5.737-1.925 0Z"
        fill="#303030"
      />
    </svg>
  ),
  chatBubble: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      {...props}
    >
      <path
        d="M16.466 0H2.496A2.502 2.502 0 0 0 0 2.496v9.55a2.502 2.502 0 0 0 2.496 2.496h9.87l4.832 3.275c.184.137.413.183.619.183.183 0 .366-.046.526-.137a1.13 1.13 0 0 0 .596-.985V2.496A2.454 2.454 0 0 0 16.466 0Z"
        fill="#fff"
      />
    </svg>
  ),
  contextMenu: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" />
      <path d="M3 18C4.65685 18 6 16.6569 6 15C6 13.3431 4.65685 12 3 12C1.34315 12 0 13.3431 0 15C0 16.6569 1.34315 18 3 18Z" />
      <path d="M15 6C16.6569 6 18 4.65685 18 3C18 1.34315 16.6569 0 15 0C13.3431 0 12 1.34315 12 3C12 4.65685 13.3431 6 15 6Z" />
      <path d="M15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C13.3431 12 12 13.3431 12 15C12 16.6569 13.3431 18 15 18Z" />
    </svg>
  ),
  needHelp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
      <circle cx="13" cy="13" r="13" fill="#303030" />
      <circle cx="13" cy="13" r="13" fill="#000" fillOpacity=".2" />
      <path
        d="m12.846 7.005.244.022a4.753 4.753 0 0 1 1.745.453c.49.225.906.581 1.204 1.03.228.353.368.754.41 1.172.047.361.018.728-.086 1.077-.13.417-.354.797-.656 1.112a7.486 7.486 0 0 1-1.132.93c-.226.156-.428.319-.64.482-.193.159-.338.368-.42.604-.044.122-.097.245-.144.367a.843.843 0 0 1-.788.559 1.102 1.102 0 0 1-.572-.09.936.936 0 0 1-.514-.7 1.607 1.607 0 0 1 .272-1.2c.195-.286.435-.54.71-.751.297-.242.602-.473.906-.715.251-.193.462-.434.62-.709a1.328 1.328 0 0 0-.159-1.47 1.222 1.222 0 0 0-.679-.376 2.161 2.161 0 0 0-1.054.018 1.284 1.284 0 0 0-.817.679c-.107.199-.2.403-.3.604-.072.152-.171.29-.291.41a1.012 1.012 0 0 1-.767.246 1.062 1.062 0 0 1-.485-.13.837.837 0 0 1-.452-.748 2.19 2.19 0 0 1 .452-1.385 3.49 3.49 0 0 1 1.358-1.1 4.142 4.142 0 0 1 1.288-.371L12.352 7l.494.005ZM12.396 19c-.068-.014-.136-.025-.202-.043a1.254 1.254 0 1 1 .543.02l-.11.023h-.231Z"
        fill="#fff"
      />
    </svg>
  ),
  info: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" {...props}>
      <g fill="currentColor">
        <path d="M8.5 6.52a.885.885 0 1 0 0-1.77.885.885 0 0 0 0 1.77ZM7.792 7.583h1.416v5.667H7.792V7.583Z" />
      </g>
    </svg>
  ),
  clock: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z"
      />
    </svg>
  ),
  exclamation: (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" {...props}>
      <g clipPath="url(#a)" fill="currentColor">
        <path d="M14.665 7.556a2.278 2.278 0 0 1 .463 1.89l-1.001 5.005a1.251 1.251 0 1 1-2.503 0l-1-5.005a2.276 2.276 0 0 1 .462-1.89 2.353 2.353 0 0 1 3.58 0ZM12.9 19.23a1.251 1.251 0 1 0 0-2.502 1.251 1.251 0 0 0 0 2.503Z" />
      </g>
    </svg>
  ),
  asterisk: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M9.63 6.97 7.963 6l1.624-.953a1 1 0 1 0-.983-1.743L7 4.253v-1.92a1 1 0 0 0-2 0v1.92l-1.617-.95a1 1 0 1 0-1 1.726L4.05 6l-1.65.953a1 1 0 1 0 .983 1.74L5 7.747v1.886a1 1 0 1 0 2 .034v-1.92l1.617.95a1 1 0 1 0 1-1.727h.013Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="12" height="12" rx="6" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  ),
  socialFacebook: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.00195 12.0018C2.00252 14.3832 2.85242 16.6862 4.39892 18.497C5.94541 20.3078 8.08707 21.5076 10.439 21.8808V14.8918H7.90195V12.0018H10.442V9.80184C10.3859 9.28693 10.4438 8.76598 10.6118 8.276C10.7797 7.78602 11.0535 7.33903 11.4136 6.96677C11.7737 6.59451 12.2114 6.30611 12.6956 6.12206C13.1797 5.93801 13.6985 5.86282 14.215 5.90184C14.965 5.91384 15.715 5.98084 16.455 6.10184V8.56084H15.191C14.9761 8.5327 14.7577 8.5532 14.5519 8.62082C14.346 8.68844 14.158 8.80145 14.0017 8.9515C13.8454 9.10156 13.7249 9.28481 13.6489 9.48773C13.573 9.69065 13.5436 9.90804 13.563 10.1238V12.0018H16.334L15.891 14.8928H13.563V21.8808C15.4506 21.5825 17.2132 20.7496 18.6421 19.4806C20.071 18.2116 21.1064 16.5598 21.6257 14.7207C22.145 12.8815 22.1264 10.9321 21.5721 9.10317C21.0179 7.27426 19.9512 5.64247 18.4983 4.40098C17.0455 3.15949 15.2673 2.36031 13.3743 2.09804C11.4814 1.83578 9.55287 2.12141 7.81721 2.92114C6.08154 3.72086 4.61137 5.00118 3.58076 6.61051C2.55015 8.21985 2.00226 10.0908 2.00195 12.0018V12.0018Z"
        fill="#2FAEF3"
      />
    </svg>
  ),
  socialInstagram: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="12" fill="#2FAEF3" />
      <g clipPath="url(#clip0_43_935)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.7325 6.533C10.319 6.506 10.506 6.5 12 6.5C13.494 6.5 13.681 6.5065 14.267 6.533C14.853 6.5595 15.253 6.653 15.603 6.7885C15.9695 6.927 16.302 7.1435 16.577 7.4235C16.857 7.698 17.073 8.03 17.211 8.397C17.347 8.747 17.44 9.147 17.467 9.732C17.494 10.3195 17.5 10.5065 17.5 12C17.5 13.494 17.4935 13.681 17.467 14.2675C17.4405 14.8525 17.347 15.2525 17.211 15.6025C17.073 15.9695 16.8566 16.3021 16.577 16.577C16.302 16.857 15.9695 17.073 15.603 17.211C15.253 17.347 14.853 17.44 14.268 17.467C13.681 17.494 13.494 17.5 12 17.5C10.506 17.5 10.319 17.4935 9.7325 17.467C9.1475 17.4405 8.7475 17.347 8.3975 17.211C8.03046 17.073 7.69791 16.8566 7.423 16.577C7.14319 16.3023 6.92666 15.9699 6.7885 15.603C6.653 15.253 6.56 14.853 6.533 14.268C6.506 13.6805 6.5 13.4935 6.5 12C6.5 10.506 6.5065 10.319 6.533 9.733C6.5595 9.147 6.653 8.747 6.7885 8.397C6.92686 8.03004 7.14356 7.69766 7.4235 7.423C7.69802 7.14325 8.03024 6.92672 8.397 6.7885C8.747 6.653 9.147 6.56 9.732 6.533H9.7325ZM14.2225 7.523C13.6425 7.4965 13.4685 7.491 12 7.491C10.5315 7.491 10.3575 7.4965 9.7775 7.523C9.241 7.5475 8.95 7.637 8.756 7.7125C8.4995 7.8125 8.316 7.931 8.1235 8.1235C7.94102 8.30103 7.80059 8.51714 7.7125 8.756C7.637 8.95 7.5475 9.241 7.523 9.7775C7.4965 10.3575 7.491 10.5315 7.491 12C7.491 13.4685 7.4965 13.6425 7.523 14.2225C7.5475 14.759 7.637 15.05 7.7125 15.244C7.8005 15.4825 7.941 15.699 8.1235 15.8765C8.301 16.059 8.5175 16.1995 8.756 16.2875C8.95 16.363 9.241 16.4525 9.7775 16.477C10.3575 16.5035 10.531 16.509 12 16.509C13.469 16.509 13.6425 16.5035 14.2225 16.477C14.759 16.4525 15.05 16.363 15.244 16.2875C15.5005 16.1875 15.684 16.069 15.8765 15.8765C16.059 15.699 16.1995 15.4825 16.2875 15.244C16.363 15.05 16.4525 14.759 16.477 14.2225C16.5035 13.6425 16.509 13.4685 16.509 12C16.509 10.5315 16.5035 10.3575 16.477 9.7775C16.4525 9.241 16.363 8.95 16.2875 8.756C16.1875 8.4995 16.069 8.316 15.8765 8.1235C15.699 7.94104 15.4829 7.80061 15.244 7.7125C15.05 7.637 14.759 7.5475 14.2225 7.523V7.523ZM11.2975 13.6955C11.6898 13.8588 12.1267 13.8809 12.5335 13.7579C12.9402 13.6349 13.2917 13.3745 13.5278 13.0211C13.7639 12.6678 13.87 12.2434 13.828 11.8206C13.786 11.3977 13.5985 11.0025 13.2975 10.7025C13.1056 10.5107 12.8736 10.3639 12.6182 10.2726C12.3627 10.1812 12.0902 10.1477 11.8202 10.1743C11.5503 10.2009 11.2896 10.2871 11.0569 10.4266C10.8242 10.566 10.6254 10.7554 10.4747 10.9809C10.3239 11.2065 10.2251 11.4626 10.1853 11.731C10.1454 11.9993 10.1656 12.2731 10.2443 12.5328C10.323 12.7924 10.4582 13.0313 10.6404 13.2324C10.8225 13.4334 11.0469 13.5916 11.2975 13.6955ZM10.001 10.001C10.2635 9.73849 10.5752 9.53025 10.9181 9.38818C11.2611 9.24611 11.6288 9.17299 12 9.17299C12.3712 9.17299 12.7389 9.24611 13.0819 9.38818C13.4248 9.53025 13.7365 9.73849 13.999 10.001C14.2615 10.2635 14.4697 10.5752 14.6118 10.9181C14.7539 11.2611 14.827 11.6288 14.827 12C14.827 12.3712 14.7539 12.7389 14.6118 13.0819C14.4697 13.4248 14.2615 13.7365 13.999 13.999C13.4688 14.5292 12.7498 14.827 12 14.827C11.2502 14.827 10.5312 14.5292 10.001 13.999C9.47083 13.4688 9.17299 12.7498 9.17299 12C9.17299 11.2502 9.47083 10.5312 10.001 10.001V10.001ZM15.454 9.594C15.5191 9.53263 15.5711 9.45884 15.6072 9.37699C15.6432 9.29513 15.6624 9.20688 15.6637 9.11746C15.665 9.02805 15.6484 8.93927 15.6147 8.8564C15.5811 8.77354 15.5312 8.69826 15.468 8.63502C15.4047 8.57178 15.3295 8.52188 15.2466 8.48826C15.1637 8.45464 15.075 8.43799 14.9855 8.43929C14.8961 8.44059 14.8079 8.45983 14.726 8.49585C14.6442 8.53187 14.5704 8.58395 14.509 8.649C14.3897 8.77551 14.3243 8.94356 14.3269 9.11746C14.3294 9.29137 14.3996 9.45744 14.5226 9.58042C14.6456 9.7034 14.8116 9.77361 14.9855 9.77615C15.1594 9.77868 15.3275 9.71334 15.454 9.594V9.594Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_43_935">
          <rect width="12" height="12" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  socialLinkedIn: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_43_933)">
        <path
          d="M12 0.47998C5.63758 0.47998 0.47998 5.63758 0.47998 12C0.47998 18.3624 5.63758 23.52 12 23.52C18.3624 23.52 23.52 18.3624 23.52 12C23.52 5.63758 18.3624 0.47998 12 0.47998ZM9.17998 16.7748H6.84718V9.26758H9.17998V16.7748ZM7.99918 8.34598C7.26238 8.34598 6.78598 7.82398 6.78598 7.17838C6.78598 6.51958 7.27678 6.01318 8.02918 6.01318C8.78158 6.01318 9.24238 6.51958 9.25678 7.17838C9.25678 7.82398 8.78158 8.34598 7.99918 8.34598ZM17.7 16.7748H15.3672V12.6144C15.3672 11.646 15.0288 10.9884 14.1852 10.9884C13.5408 10.9884 13.158 11.4336 12.9888 11.862C12.9264 12.0144 12.9108 12.2304 12.9108 12.4452V16.7736H10.5768V11.6616C10.5768 10.7244 10.5468 9.94078 10.5156 9.26638H12.5424L12.6492 10.3092H12.696C13.0032 9.81958 13.7556 9.09718 15.0144 9.09718C16.5492 9.09718 17.7 10.1256 17.7 12.336V16.7748V16.7748Z"
          fill="#2FAEF3"
        />
      </g>
      <defs>
        <clipPath id="clip0_43_933">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  socialTwitter: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM17.0461 9.41484C17.0531 9.525 17.0531 9.63984 17.0531 9.75234C17.0531 13.193 14.4328 17.1562 9.64453 17.1562C8.16797 17.1562 6.79922 16.7273 5.64609 15.9891C5.85703 16.0125 6.05859 16.0219 6.27422 16.0219C7.49297 16.0219 8.61328 15.6094 9.50625 14.9109C8.3625 14.8875 7.40156 14.1375 7.07344 13.1063C7.47422 13.1648 7.83516 13.1648 8.24766 13.0594C7.65873 12.9397 7.12939 12.6199 6.74957 12.1542C6.36974 11.6885 6.16286 11.1056 6.16406 10.5047V10.4719C6.50859 10.6664 6.91406 10.7859 7.33828 10.8023C6.98166 10.5647 6.6892 10.2427 6.48682 9.86491C6.28445 9.48715 6.17841 9.06528 6.17813 8.63672C6.17813 8.15156 6.30469 7.70859 6.53203 7.32422C7.18571 8.12891 8.0014 8.78705 8.92609 9.25586C9.85078 9.72466 10.8638 9.99364 11.8992 10.0453C11.5313 8.27578 12.8531 6.84375 14.4422 6.84375C15.1922 6.84375 15.8672 7.15781 16.343 7.66406C16.9312 7.55391 17.4937 7.33359 17.9953 7.03828C17.8008 7.64062 17.393 8.14922 16.8516 8.47031C17.3766 8.41406 17.8828 8.26875 18.3516 8.06484C17.9977 8.58516 17.5547 9.04688 17.0461 9.41484V9.41484Z"
        fill="#2FAEF3"
      />
    </svg>
  ),
  socialYoutube: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="12" fill="#2FAEF3" />
      <path
        d="M17.0309 9.46992C16.9711 9.24731 16.8539 9.0443 16.691 8.88121C16.5281 8.71813 16.3253 8.60068 16.1027 8.54063C15.2836 8.32031 12 8.32031 12 8.32031C12 8.32031 8.71641 8.32031 7.89727 8.53945C7.67463 8.59931 7.47167 8.71669 7.30876 8.87981C7.14584 9.04293 7.02872 9.24604 6.96914 9.46875C6.75 10.2891 6.75 12 6.75 12C6.75 12 6.75 13.7109 6.96914 14.5301C7.08984 14.9824 7.44609 15.3387 7.89727 15.4594C8.71641 15.6797 12 15.6797 12 15.6797C12 15.6797 15.2836 15.6797 16.1027 15.4594C16.5551 15.3387 16.9102 14.9824 17.0309 14.5301C17.25 13.7109 17.25 12 17.25 12C17.25 12 17.25 10.2891 17.0309 9.46992ZM10.957 13.5703V10.4297L13.6758 11.9883L10.957 13.5703Z"
        fill="white"
      />
    </svg>
  ),
  addPlusSign: (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="15" height="15" viewBox="0 0 15 15" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66756 0.745422V6.6675H0.745483V8.64153H6.66756V14.5636H8.64159V8.64153H14.5637V6.6675H8.64159V0.745422H6.66756Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export default icons;
